import React from "react";

export const BookingScreen = React.lazy(() => import("./BookingScreen"));
export const BookingSettingsPage = React.lazy(
  () => import("./BookingSettingsPage"),
);
